import { render, staticRenderFns } from "./ReportsGroupTable.vue?vue&type=template&id=a10a3fa4"
import script from "./ReportsGroupTable.vue?vue&type=script&lang=js"
export * from "./ReportsGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports